module.exports = __webpack_public_path__ + "static/media/successfulTransference.92659eb2.svg";